import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/app/global-error.tsx");
